// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ProviderClearinghouseEraItemCharge,
    ProviderClearinghouseEraItemChargeFromJSON,
    ProviderClearinghouseEraItemChargeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderClearinghouseEraItem
 */
export interface ProviderClearinghouseEraItem {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    id?: string;
    /**
     * Provider NPI
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    npi?: string;
    /**
     * Patient control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    pcn?: string;
    /**
     * Payer internal control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    icn?: string;
    /**
     * Subscriber insurance number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    subscriberId?: string;
    /**
     * Subscriber first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    subscriberFirst?: string;
    /**
     * Subscriber last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    subscriberLast?: string;
    /**
     * Patient first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    patientFirst?: string;
    /**
     * Patient last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    patientLast?: string;
    /**
     * From date of service
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClearinghouseEraItem
     */
    fromDos?: string;
    /**
     * Through date of service
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClearinghouseEraItem
     */
    throughDos?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderClearinghouseEraItem
     */
    chargeAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderClearinghouseEraItem
     */
    paidAmount?: Amount;
    /**
     * The status code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    statusCode?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderClearinghouseEraItemCharge>}
     * @memberof ProviderClearinghouseEraItem
     */
    charges?: Array<ProviderClearinghouseEraItemCharge>;
    /**
     * The crossover carrier (a payer this payer forwarded the claim to)
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    crossoverCarrier?: string;
    /**
     * The class of contract code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    contract?: string;
    /**
     * The group or policy number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    groupId?: string;
    /**
     * Active payment IDs belonging to the current account. An empty list means this item has no active posted payments. Retrieve a payment using GET /provider/payment/{id}.
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderClearinghouseEraItem
     */
    paymentIds?: Array<string>;
    /**
     * The clearinghouse ERA this clearinghouse era item belongs to.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClearinghouseEraItem
     */
    clearinghouseEraId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClearinghouseEraItem
     */
    created?: string;
}

export function ProviderClearinghouseEraItemFromJSON(json: any): ProviderClearinghouseEraItem {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'npi': !exists(json, 'npi') ? undefined : json['npi'],
            'pcn': !exists(json, 'pcn') ? undefined : json['pcn'],
            'icn': !exists(json, 'icn') ? undefined : json['icn'],
            'subscriberId': !exists(json, 'subscriberId') ? undefined : json['subscriberId'],
            'subscriberFirst': !exists(json, 'subscriberFirst') ? undefined : json['subscriberFirst'],
            'subscriberLast': !exists(json, 'subscriberLast') ? undefined : json['subscriberLast'],
            'patientFirst': !exists(json, 'patientFirst') ? undefined : json['patientFirst'],
            'patientLast': !exists(json, 'patientLast') ? undefined : json['patientLast'],
            'fromDos': !exists(json, 'fromDos') ? undefined : json['fromDos'],
            'throughDos': !exists(json, 'throughDos') ? undefined : json['throughDos'],
            'chargeAmount': !exists(json, 'chargeAmount') ? undefined : AmountFromJSON(json['chargeAmount']),
            'paidAmount': !exists(json, 'paidAmount') ? undefined : AmountFromJSON(json['paidAmount']),
            'statusCode': !exists(json, 'statusCode') ? undefined : json['statusCode'],
            'charges': !exists(json, 'charges') ? undefined : (json['charges'] as Array<any>).map(ProviderClearinghouseEraItemChargeFromJSON),
            'crossoverCarrier': !exists(json, 'crossoverCarrier') ? undefined : json['crossoverCarrier'],
            'contract': !exists(json, 'contract') ? undefined : json['contract'],
            'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
            'paymentIds': !exists(json, 'paymentIds') ? undefined : json['paymentIds'],
            'clearinghouseEraId': !exists(json, 'clearinghouseEraId') ? undefined : json['clearinghouseEraId'],
            'created': !exists(json, 'created') ? undefined : json['created'],
    };

}

export function ProviderClearinghouseEraItemToForm(value?: ProviderClearinghouseEraItem): any {
    let jsonVal = ProviderClearinghouseEraItemToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderClearinghouseEraItemToJSON(value?: ProviderClearinghouseEraItem): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'npi': cleanupBlankValuesForBackend(value.npi),
            'pcn': cleanupBlankValuesForBackend(value.pcn),
            'icn': cleanupBlankValuesForBackend(value.icn),
            'subscriberId': cleanupBlankValuesForBackend(value.subscriberId),
            'subscriberFirst': cleanupBlankValuesForBackend(value.subscriberFirst),
            'subscriberLast': cleanupBlankValuesForBackend(value.subscriberLast),
            'patientFirst': cleanupBlankValuesForBackend(value.patientFirst),
            'patientLast': cleanupBlankValuesForBackend(value.patientLast),
            'fromDos': cleanupBlankValuesForBackend(value.fromDos),
            'throughDos': cleanupBlankValuesForBackend(value.throughDos),
            'chargeAmount': AmountToJSON(value.chargeAmount),
            'paidAmount': AmountToJSON(value.paidAmount),
            'statusCode': cleanupBlankValuesForBackend(value.statusCode),
            'charges': (value.charges === undefined || value.charges === null) ? undefined : (value.charges as Array<any>).map(ProviderClearinghouseEraItemChargeToJSON),
            'crossoverCarrier': cleanupBlankValuesForBackend(value.crossoverCarrier),
            'contract': cleanupBlankValuesForBackend(value.contract),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'paymentIds': cleanupBlankValuesForBackend(value.paymentIds),
            'clearinghouseEraId': cleanupBlankValuesForBackend(value.clearinghouseEraId),
            'created': cleanupBlankValuesForBackend(value.created),
    };
}


